import { cn } from "@/lib/utils";
import { IconBaseProps } from "react-icons";
import { LuLoaderCircle } from "react-icons/lu";

const LoadingSpinner = ({ className, ...props }: IconBaseProps) => (
  <LuLoaderCircle className={cn("animate-spin", className)} {...props} />
);
export default LoadingSpinner;
